<template>
  <v-card>
        <v-col cols="12">
        <v-card outlined :color="testResults.is_passed? '#d7ffd7' : '#ffeccf'">
            <v-list-item three-line>
            <v-list-item-content>
                <div class="text-overline mb-4">
                </div>
                <v-list-item-title class="text-h5 mb-1 text-uppercase">
                <span  v-if="testResults.is_passed">  <v-icon large color="green darken-2" class="mr-2">mdi-checkbox-marked-circle</v-icon>{{ 'passed' | translate }} </span>
                <span  v-else><v-icon large color="red darken-2" class="mr-2">mdi-alert-circle-outline</v-icon>{{ 'failed' | translate }} </span>
                </v-list-item-title>
            </v-list-item-content>


            <v-avatar size="100">
                <v-img
                v-if="testResults.test_image"
                class="elevation-6"
                :src="storage_url + testResults.test_image"
                ></v-img>
            </v-avatar>


            </v-list-item>
        </v-card>
        
        <v-card outlined>
            <v-card-text class="card-body no-gutters" >
                <div class="row no-gutters">
                {{ testResults.module_id }}
                <div class="col-sm-3">{{ testResults.module_id?  "Test" : "Exam" | translate}}</div>
                <div class="col-sm-9">{{ testResults.test_name }}</div>
                </div>
                <hr>
                <div class="row no-gutters" v-if="testResults.module_id">
                <div class="col-sm-3"> {{ "Module" | translate}}</div>
                <div class="col-sm-9">{{ testResults.title }}</div>
                </div>
                <hr v-if="testResults.module_id">
                <div class="row no-gutters">
                <div class="col-sm-3"> {{ "Attempt" | translate}}</div>
                <div class="col-sm-9">{{ testResults.attempt }}</div>
                </div>
                <hr>
                <div class="row no-gutters">
                <div class="col-sm-3"> {{ testResults.module_id? "Test Taken on" : "Exam Taken on" | translate}}</div>
                <div class="col-sm-9">{{ testResults.created_at }}</div>
                </div>
                <hr>
                <div class="row no-gutters">
                <div class="col-sm-3"> {{ "Time taken" | translate}}</div>
                <div class="col-sm-9">{{ testResults.seconds }}</div>
                </div>
                <hr>
                <div class="row no-gutters">
                <div class="col-sm-3"> {{ "Your score" | translate}}</div>
                <div class="col-sm-9">{{ testResults.scored_percentage }}%</div>
                </div>
                <hr>
                <div class="row no-gutters">
                <div class="col-sm-3"> {{ "Percent of passing is" | translate}}</div>
                <div class="col-sm-9">{{ testResults.passing_percentage }}%</div>
                </div>
                <hr>
            </v-card-text>
        </v-card>
        </v-col>
        <v-col cols="12">
                <v-col cols="12"  v-for="testans in testResults.test_answers" :key="testans.id">
                <v-card>
                <v-card-title class="question-title">{{testans.question.question_text}} <v-spacer></v-spacer><span class="maxpointsbadge">{{testans.question.scored_points}}/{{ testans.question.total_points}}</span></v-card-title>
                    <v-list>
                    <v-list-item
                        v-for="answerdata in testans.question.answers"
                        :key="answerdata.answer_id"
                        class="answer-option"
                    >
                            <v-list-item-title v-if="answerdata.selected" class="seletedbadge"><v-icon large >mdi-circle-small</v-icon>{{ answerdata.answer_text }} <span class="badge">{{answerdata.answer_points}}</span></v-list-item-title> 
                            <v-list-item-title v-if="!answerdata.selected" ><v-icon large >mdi-circle-small</v-icon>{{ answerdata.answer_text }} <span class="badge mr-2">{{answerdata.answer_points}}</span></v-list-item-title> 
                            
                    </v-list-item>
                    </v-list> 
                </v-card>
                </v-col>
        </v-col>
          <v-row>
          </v-row>
        </v-card>
    </template>



<script>
    import { mapGetters } from "vuex";
    export default {
    name: "Message",
    props:{
        testResults: Object,
    },

    data: () => ({
        storage_url: "",
        company_storage_url: "",
    }),
    methods: {
    },
    computed: {
        ...mapGetters([
        "languages",
        "currentUser",
        ]),
    },
    created() {
        this.storage_url = process.env.VUE_APP_STORAGE_URL;
        this.company_storage_url = process.env.VUE_APP_COMPANYADMIN_STORAGE_URL;
        
    },
    };
</script>

<style scoped>
.badge {
  background-color: rgb(66, 66, 66);
  color: white;
  padding: 4px 8px;
  text-align: center;
  border-radius: 5px;
  float:right;
  margin-top: 4px;
}

.seletedbadge {
  background-color: rgb(213, 213, 213);
  padding: 0px 8px;
  border-radius: 5px;
}

.maxpointsbadge{
  background-color: green;
  color: white;
  padding: 4px 8px;
  border-radius: 20px;
}

.test-result-table{
  cursor:pointer;
}

.answer-option{
    min-height: 0px
}

.question-title{
    padding-bottom: 0px;
}

</style>